import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { WasteStreamBinSize } from "@/api/Shared";

export type CreateRequestRequest = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  unitNumber: string;
  streetNumber: string;
  streetName: string;
  suburb: string;
  postcode: string;
  state: string;
  assessmentNumber: string;
  requestType: string;
  taskType: string;
  wasteStreams: WasteStreamBinSize[];
  requestNotes: string;
  moreInformation: string[];
  deadAnimalSize: string;
  animalType: string;
};

export type CreateRequestResponse = {
  created: boolean;
};

export const createRequest = async (request: CreateRequestRequest) => {
  const response = await executeApiRequest(
    () => axios.post<CreateRequestResponse>("/requests/create", request, { withCredentials: true }),
    false
  );
  return response?.data;
};
